import { render, staticRenderFns } from "./assignBusRouteStudentListing.vue?vue&type=template&id=a129f466"
import script from "./assignBusRouteStudentListing.vue?vue&type=script&lang=js"
export * from "./assignBusRouteStudentListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports